export const MONTLY_SUBSCRIPTION = "rotosub1";
export const YEARLY_SUBSCRIPTION = "rotosubs2";
export const PRESEASON_SUBSCRIPTION = "rotosubs3";